import { DATA_GRID_INITIAL_STATE } from "../../../components/ui/dataGridStyles";

/**
 * Props propias de los DataGrid del feature (el aspecto común vive en
 * components/ui/dataGridStyles.js). Definidas fuera del render para no
 * recrearlas en cada render.
 */
export const COLUMNAS_INICIALES = { columns: { columnVisibilityModel: { id: false } } };

// Paginación estándar + columna id oculta
export const ESTADO_INICIAL_GRID = { ...DATA_GRID_INITIAL_STATE, ...COLUMNAS_INICIALES };
